export const apiRootDomain = "api.swiss-bitcoin-pay.ch";
export const apiRootUrl = `https://${apiRootDomain}`;
